import _ from 'lodash';

export const pickData = (data: any, ALLOWED_FIELDS: string[]) => {
  return _.pick(data, ALLOWED_FIELDS);
};
